var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dashboard"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4.95435C10.3401 4.95435 8.72133 5.47066 7.36799 6.43173C6.01464 7.39281 4.99375 8.75105 4.4468 10.3182C3.89984 11.8854 3.85391 13.5839 4.31536 15.1784C4.74525 16.6638 5.59567 17.9903 6.76061 18.9999H17.2394C18.4043 17.9903 19.2547 16.6638 19.6846 15.1784C20.1461 13.5839 20.1002 11.8854 19.5532 10.3182C19.0062 8.75105 17.9854 7.39281 16.632 6.43173C15.2787 5.47066 13.6599 4.95435 12 4.95435ZM6.20998 4.80108C7.90167 3.59974 9.92515 2.95435 12 2.95435C14.0749 2.95435 16.0983 3.59974 17.79 4.80108C19.4817 6.00243 20.7578 7.70023 21.4415 9.6592C22.1252 11.6182 22.1826 13.7413 21.6058 15.7344C21.029 17.7274 19.8465 19.4917 18.2222 20.7828C18.0453 20.9234 17.826 20.9999 17.6 20.9999H6.4C6.17401 20.9999 5.95469 20.9234 5.77778 20.7828C4.1535 19.4917 2.97101 17.7274 2.3942 15.7344C1.81738 13.7413 1.8748 11.6182 2.55849 9.6592C3.24219 7.70023 4.5183 6.00243 6.20998 4.80108ZM16.2071 8.79289C16.5976 9.18342 16.5976 9.81658 16.2071 10.2071L14.7076 11.7066C14.895 12.0982 15 12.5369 15 13C15 14.6569 13.6569 16 12 16C10.3431 16 9 14.6569 9 13C9 11.3431 10.3431 10 12 10C12.4632 10 12.9018 10.105 13.2934 10.2924L14.7929 8.79289C15.1834 8.40237 15.8166 8.40237 16.2071 8.79289ZM12 12C11.4477 12 11 12.4477 11 13C11 13.5523 11.4477 14 12 14C12.5523 14 13 13.5523 13 13C13 12.4477 12.5523 12 12 12Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.3396bb4cdfd080fff556d912a9a1ac14.svg";
export { ForwardRef as ReactComponent };